import { render, staticRenderFns } from "./ApprovalMPR.vue?vue&type=template&id=4fb3ed5a"
import script from "./ApprovalMPR.vue?vue&type=script&lang=js"
export * from "./ApprovalMPR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports